import styled, { css } from 'styled-components';
import { Button as Btn } from 'core/components/Login/LoginWorkflow/SignIn/signInStyles';
import Inpt from 'core/components/Form/Input';
import { desktop } from 'core/components/Form/formStyles';

export const Form = styled.form`
	text-align: center;
`;

export const Button = styled(Btn)`
	margin-top: 24px;
	width: 100%;
	font-size: 16px;
	padding-top: 15px;
	padding-bottom: 15px;
	height: 48px;
	font-weight: 500;
	box-shadow: 0 2px 4px 0 rgba(74, 74, 74, 0.3);

	${desktop`
		height: 54px;
	`}
`;

export const Input = styled(Inpt)`
	margin-top: 24px;
`;
